interface GenerateSnowflakeConnectionStepsArgs {
  activeStep: number;
  isCommandGenerated: boolean;
  isConnectionCreated: boolean;
}

export const generateSnowflakeConnectionSteps = ({
  activeStep,
  isCommandGenerated,
  isConnectionCreated,
}: GenerateSnowflakeConnectionStepsArgs) => {
  return [
    {
      index: 0,
      label: "Details",
      completed: activeStep > 0 && isCommandGenerated,
      enabled: true,
    },
    {
      index: 1,
      label: "Access",
      completed: activeStep > 1,
      enabled: isCommandGenerated,
    },
    {
      index: 2,
      label: "Collecting Data",
      completed: false,
      enabled: isCommandGenerated && isConnectionCreated,
    },
  ];
};
